<template>
  <el-form :inline="true" :model="formData" class="demo-form-inline" size="small">
    <template v-for="(item, index) in formList">
      <el-form-item
        :label="item.label"
        :key="index"
        class="screen"
        :class="{
          timeModel: item.type === 'datePicker',
          numberPicker: item.type === 'numberPicker',
        }"
      >
        <template v-if="item.type === 'input'">
          <el-input
            v-model="formData[item.model]"
            :placeholder="item.placeholder"
            :clearable="item.clearable"
            @clear="clear"
            style="max-width: 188px"
          ></el-input>
        </template>
        <template v-else-if="item.type === 'select'">
          <el-select
            v-model="formData[item.model]"
            :placeholder="item.placeholder"
            @clear="clear"
            filterable
            style="max-width: 188px"
          >
            <el-option
              v-for="(opt, i) in item.optionList"
              :key="i"
              :label="opt[item.labelName]"
              :value="opt[item.valueName]"
            ></el-option>
          </el-select>
        </template>

        <!-- 年份范围选择器 -->
        <template v-else-if="item.type === 'datePicker'">
          <el-col :span="10">
            <el-date-picker
              type="date"
              :placeholder="item.placeholder1"
              v-model="formData[item.model1]"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @clear="clear"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="10">
            <el-date-picker
              type="date"
              :placeholder="item.placeholder2"
              v-model="formData[item.model2]"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @clear="clear"
            ></el-date-picker>
          </el-col>
        </template>

        <!-- 月份范围选择器 -->
        <template v-else-if="item.type === 'monthPicker'">
          <el-date-picker
            v-model="formData[item.model]"
            type="month"
            :value-format="item.valueFormat"
            :placeholder="item.placeholder"
            :clearable="false"
            @clear="clear"
          >
          </el-date-picker>
        </template>

        <!-- 数字范围选择器 -->
        <template v-else-if="item.type === 'numberPicker'">
          <el-col :span="10">
            <el-select
              v-model="formData[item.model1]"
              :placeholder="item.placeholder1"
              filterable
              @clear="clear"
            >
              <template v-for="(num, index) in item.endNum / item.increase">
                <el-option
                  v-if="
                    formData[item.model2] === ''
                      ? num * item.increase <= item.endNum
                      : num * item.increase < formData[item.model2]
                  "
                  :key="index"
                  :label="num * item.increase + ' 元'"
                  :value="num * item.increase"
                >
                </el-option>
              </template>
            </el-select>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="10">
            <el-select
              v-model="formData[item.model2]"
              :placeholder="item.placeholder2"
              filterable
              @clear="clear"
            >
              <template v-for="(num, index) in item.endNum / item.increase">
                <el-option
                  v-if="num * item.increase > formData[item.model1]"
                  :key="index"
                  :label="num * item.increase + ' 元'"
                  :value="num * item.increase"
                >
                </el-option>
              </template>
            </el-select>
          </el-col>
        </template>
      </el-form-item>
    </template>
    <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">重置</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: "Query",
  props: {
    // form表单
    formData: {
      type: Object,
    },
    // 表单内容
    formList: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
    query() {
      this.$emit("query", this.formData);
    },
    clear() {
      this.$emit("clear");
    },
  },
};
</script>

<style lang="less" scoped>
.fc{
  width: 150px;
}
/deep/.el-input-group__prepend,
/deep/.el-input__inner {
  border: none;
  background-color: transparent;
  color: #989898;
  font-size: 14px;
}
/deep/.el-form-item__label {
  color: #989898;
  font-size: 14px;
}
.timeModel {
  /deep/.el-form-item__content {
    width: 320px;
    .line {
      text-align: center;
    }
  }
}
.numberPicker {
  /deep/.el-form-item__content {
    width: 300px;
    .line {
      text-align: center;
    }
  }
}
</style>